/*!
 * Copyright Zendesk, Inc.
 * 
 * Use of this source code is governed under the Apache License, Version 2.0
 * found at http://www.apache.org/licenses/LICENSE-2.0
 */
(function (e, a) {
  for (var i in a) {
    e[i] = a[i];
  }
})(exports,
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        enumerable: true,
        get: getter
      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // define __esModule on exports

  /******/


  __webpack_require__.r = function (exports) {
    /******/
    if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
      /******/
      Object.defineProperty(exports, Symbol.toStringTag, {
        value: 'Module'
      });
      /******/
    }
    /******/


    Object.defineProperty(exports, '__esModule', {
      value: true
    });
    /******/
  };
  /******/

  /******/
  // create a fake namespace object

  /******/
  // mode & 1: value is a module id, require it

  /******/
  // mode & 2: merge all properties of value into the ns

  /******/
  // mode & 4: return value when already ns object

  /******/
  // mode & 8|1: behave like require

  /******/


  __webpack_require__.t = function (value, mode) {
    /******/
    if (mode & 1) value = __webpack_require__(value);
    /******/

    if (mode & 8) return value;
    /******/

    if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
    /******/

    var ns = Object.create(null);
    /******/

    __webpack_require__.r(ns);
    /******/


    Object.defineProperty(ns, 'default', {
      enumerable: true,
      value: value
    });
    /******/

    if (mode & 2 && typeof value != 'string') for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    /******/

    return ns;
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 5);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports) {
  module.exports = require("@zendeskgarden/react-theming");
  /***/
},
/* 1 */

/***/
function (module, exports) {
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */
  module.exports = {
    zdColorBlack: '#000',
    zdColorGreen100: '#edf8f4',
    zdColorGreen200: '#d1e8df',
    zdColorGreen300: '#aecfc2',
    zdColorGreen400: '#5eae91',
    zdColorGreen500: '#228f67',
    zdColorGreen600: '#038153',
    zdColorGreen700: '#186146',
    zdColorGreen800: '#0b3b29',
    zdColorGrey100: '#f8f9f9',
    zdColorGrey200: '#e9ebed',
    zdColorGrey300: '#d8dcde',
    zdColorGrey400: '#c2c8cc',
    zdColorGrey500: '#87929d',
    zdColorGrey600: '#68737d',
    zdColorGrey700: '#49545c',
    zdColorGrey800: '#2f3941',
    zdColorBlue100: '#edf7ff',
    zdColorBlue200: '#cee2f2',
    zdColorBlue300: '#adcce4',
    zdColorBlue400: '#5293c7',
    zdColorBlue500: '#337fbd',
    zdColorBlue600: '#1f73b7',
    zdColorBlue700: '#144a75',
    zdColorBlue800: '#0f3554',
    zdColorKale100: '#f5fbfc',
    zdColorKale200: '#c1d6d9',
    zdColorKale300: '#819a9e',
    zdColorKale400: '#56777a',
    zdColorKale500: '#335d63',
    zdColorKale600: '#04444d',
    zdColorKale700: '#03363d',
    zdColorKale800: '#012b30',
    zdColorRed100: '#fff0f1',
    zdColorRed200: '#f5d5d8',
    zdColorRed300: '#f5b5ba',
    zdColorRed400: '#e35b66',
    zdColorRed500: '#d93f4c',
    zdColorRed600: '#cc3340',
    zdColorRed700: '#8c232c',
    zdColorRed800: '#681219',
    zdColorYellow100: '#fff8ed',
    zdColorYellow200: '#fff0db',
    zdColorYellow300: '#fcdba9',
    zdColorYellow400: '#ffb648',
    zdColorYellow500: '#f5a133',
    zdColorYellow600: '#ed961c',
    zdColorYellow700: '#ad5e18',
    zdColorYellow800: '#703b15',
    zdColorWhite: '#fff',
    zdColorAffair: '#734988',
    zdColorAluminum: '#999',
    zdColorAntiFlashWhite: '#f3f3f3',
    zdColorAppleGreen: '#78a300',
    zdColorApricot: '#ffcab3',
    zdColorBlueChalk: '#e5d6ed',
    zdColorBuff: '#f6de86',
    zdColorButtermilk: '#ffefb3',
    zdColorCeSoir: '#9677a6',
    zdColorCgRed: '#e03b30',
    zdColorChateauGreen: '#16ba52',
    zdColorChathamsBlue: '#24536b',
    zdColorColumbiaBlue: '#a8d8ff',
    zdColorCoolBlue: '#0a91ff',
    zdColorCoralCandy: '#efcbc9',
    zdColorCremeBrulee: '#ffdc99',
    zdColorCupid: '#fab4c9',
    zdColorCuriousBlue: '#358fb2',
    zdColorDandelion: '#ffde66',
    zdColorDarkGray: '#555',
    zdColorDarkPastelRed: '#bf3026',
    zdColorDeepLilac: '#965ab6',
    zdColorDenim: '#146eaa',
    zdColorEastSide: '#b083c8',
    zdColorFestival: '#f2ce4a',
    zdColorFlamingo: '#eb6651',
    zdColorGainsboro: '#ddd',
    zdColorGoldenDream: '#efc93d',
    zdColorIndianRed: '#cf645c',
    zdColorIron: '#ccc',
    zdColorJonquil: '#ffdd5f',
    zdColorKarl: '#f3f0ee',
    zdColorLemonChiffon: '#fff3ca',
    zdColorLightCrimson: '#f3749a',
    zdColorLilyWhite: '#ebebeb',
    zdColorLola: '#b9a4c3',
    zdColorMabel: '#cce3ec',
    zdColorMagicMint: '#aaf3c4',
    zdColorMalibu: '#5ebbde',
    zdColorMandy: '#eb4962',
    zdColorMarigold: '#ffc800',
    zdColorMayaBlue: '#61b8ff',
    zdColorMonsoon: '#777',
    zdColorMoonYellow: '#edbe0e',
    zdColorMoonstoneBlue: '#6aabc4',
    zdColorNero: '#1a1a1a',
    zdColorNonPhotoBlue: '#a5dcf2',
    zdColorOasis: '#faefc3',
    zdColorOil: '#333',
    zdColorOrangePeel: '#faa300',
    zdColorPalatinateBlue: '#1438f7',
    zdColorPaleTurquoise: '#aff3ee',
    zdColorPatternsBlue: '#d2eef9',
    zdColorPelorous: '#30aabc',
    zdColorPerano: '#a6b3ff',
    zdColorPerfume: '#caacda',
    zdColorPersianGreen: '#03b3a7',
    zdColorPersimmon: '#ff6d5a',
    zdColorPetiteOrchid: '#df9792',
    zdColorPicasso: '#ffe894',
    zdColorPinkOrange: '#ff9466',
    zdColorPlatinum: '#eee',
    zdColorPortlandOrange: '#ff542e',
    zdColorRazzmatazz: '#f2316b',
    zdColorRegentStBlue: '#9ac7d8',
    zdColorRemy: '#f7cecb',
    zdColorSaffronMango: '#fac157',
    zdColorSeaBuckthorn: '#f79a3e',
    zdColorShamrock: '#45d97b',
    zdColorSilverSand: '#bbb',
    zdColorSkyBlue: '#78cdec',
    zdColorSnow: '#fbfbfb',
    zdColorSteel: '#666',
    zdColorSunglow: '#ffd12a',
    zdColorTerraCotta: '#e86c64',
    zdColorTitanWhite: '#dcd1e1',
    zdColorUltramarineBlue: '#5e76ff',
    zdColorVerdigris: '#37b8af',
    zdColorViking: '#5fd4cc',
    zdColorWewak: '#ef9d97',
    zdColorWhiteSmoke: '#f8f8f8',
    zdColorChatOrange: '#f79a3e',
    zdColorConnectRed: '#eb6651',
    zdColorExploreBlue: '#30aabc',
    zdColorGuidePink: '#eb4962',
    zdColorInboxOrange: '#ff6d5a',
    zdColorMessageGreen: '#37b8af',
    zdColorSupportGreen: '#78a300',
    zdColorTalkYellow: '#efc93d',
    zdColorAlgae: '#03363d',
    zdColorBreakerBay: '#56777a',
    zdColorDaintree: '#012b30',
    zdColorPromoOrange: '#faa300',
    zdColorSherpaBlue: '#04444d',
    zdColorSubmarine: '#819a9e',
    zdColorZendeskGreen: '#78a300',
    zdFontFamilyMonospace: 'SFMono-Regular,Consolas,"Liberation Mono",Menlo,Courier,monospace',
    zdFontFamilySystem: 'system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",Arial,sans-serif',
    zdFontSizeSm: '12px',
    zdFontSizeMd: '14px',
    zdFontSizeLg: '18px',
    zdFontSizeXl: '22px',
    zdFontSizeXxl: '26px',
    zdFontSizeXxxl: '36px',
    zdFontSizeGiga: '36px',
    zdFontSizeMega: '28px',
    zdFontSizeKilo: '25px',
    zdFontSizeAlpha: '22px',
    zdFontSizeBeta: '20px',
    zdFontSizeGamma: '18px',
    zdFontSizeDelta: '16px',
    zdFontSizeEpsilon: '14px',
    zdFontSizeZeta: '12px',
    zdFontSizeMilli: '11px',
    zdFontSizeMicro: '10px',
    zdFontSizeNano: '9px',
    zdFontWeightThin: '100',
    zdFontWeightExtralight: '200',
    zdFontWeightLight: '300',
    zdFontWeightRegular: '400',
    zdFontWeightMedium: '500',
    zdFontWeightSemibold: '600',
    zdFontWeightBold: '700',
    zdFontWeightExtrabold: '800',
    zdFontWeightBlack: '900',
    zdFontWeightUltralight: '200',
    zdFontWeightUltrabold: '800',
    zdFontWeightHeavy: '900',
    zdLineHeightSm: '16px',
    zdLineHeightMd: '20px',
    zdLineHeightLg: '24px',
    zdLineHeightXl: '28px',
    zdLineHeightXxl: '32px',
    zdLineHeightXxxl: '44px',
    zdSpacingXxs: '4px',
    zdSpacingXs: '8px',
    zdSpacingSm: '12px',
    zdSpacing: '20px',
    zdSpacingLg: '32px',
    zdSpacingXl: '40px',
    zdSpacingXxl: '48px'
  };
  /***/
},
/* 2 */

/***/
function (module, exports) {
  module.exports = require("prop-types");
  /***/
},
/* 3 */

/***/
function (module, exports) {
  module.exports = require("react");
  /***/
},
/* 4 */

/***/
function (module, exports) {
  module.exports = require("styled-components");
  /***/
},
/* 5 */

/***/
function (module, __webpack_exports__, __webpack_require__) {
  "use strict";

  __webpack_require__.r(__webpack_exports__); // EXTERNAL MODULE: external "react"


  var external_react_ = __webpack_require__(3);

  var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_); // EXTERNAL MODULE: external "prop-types"


  var external_prop_types_ = __webpack_require__(2);

  var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_); // EXTERNAL MODULE: external "styled-components"


  var external_styled_components_ = __webpack_require__(4);

  var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_); // EXTERNAL MODULE: ./node_modules/@zendeskgarden/css-variables/dist/index.js


  var dist = __webpack_require__(1); // EXTERNAL MODULE: external "@zendeskgarden/react-theming"


  var react_theming_ = __webpack_require__(0); // CONCATENATED MODULE: ./src/views/SM.js


  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var COMPONENT_ID = 'typography.sm';
  var StyledSM = external_styled_components_default.a.div.attrs({
    'data-garden-id': COMPONENT_ID,
    'data-garden-version': "0.3.0"
  }).withConfig({
    displayName: "SM__StyledSM",
    componentId: "sc-12nz8l-0"
  })(["line-height:", ";font-size:", ";direction:", ";", ";"], dist["zdLineHeightSm"], dist["zdFontSizeSm"], function (props) {
    return Object(react_theming_["isRtl"])(props) ? 'rtl' : 'ltr';
  }, function (props) {
    return Object(react_theming_["retrieveTheme"])(COMPONENT_ID, props);
  });
  /**
   * Accepts all standard props relating to provided `tag`
   */

  var SM_SM = function SM(_ref) {
    var tag = _ref.tag,
        other = _objectWithoutProperties(_ref, ["tag"]);

    var CustomTagSM = StyledSM.withComponent(tag);
    return external_react_default.a.createElement(CustomTagSM, other);
  };

  SM_SM.propTypes = {
    /** Any valid DOM element for the styled component */
    tag: external_prop_types_default.a.any
  };
  SM_SM.defaultProps = {
    tag: 'div'
  };
  /** @component */

  /* harmony default export */

  var views_SM = SM_SM; // CONCATENATED MODULE: ./src/views/MD.js

  function MD_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = MD_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function MD_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var MD_COMPONENT_ID = 'typography.md';
  var StyledMD = external_styled_components_default.a.div.attrs({
    'data-garden-id': MD_COMPONENT_ID,
    'data-garden-version': "0.3.0"
  }).withConfig({
    displayName: "MD__StyledMD",
    componentId: "sc-10p6y1g-0"
  })(["line-height:", ";font-size:", ";direction:", ";", ";"], dist["zdLineHeightMd"], dist["zdFontSizeMd"], function (props) {
    return Object(react_theming_["isRtl"])(props) ? 'rtl' : 'ltr';
  }, function (props) {
    return Object(react_theming_["retrieveTheme"])(MD_COMPONENT_ID, props);
  });
  /**
   * Accepts all standard props relating to provided `tag`
   */

  var MD_MD = function MD(_ref) {
    var tag = _ref.tag,
        other = MD_objectWithoutProperties(_ref, ["tag"]);
    var CustomTagMD = StyledMD.withComponent(tag);
    return external_react_default.a.createElement(CustomTagMD, other);
  };

  MD_MD.propTypes = {
    /** Any valid DOM element for the styled component */
    tag: external_prop_types_default.a.any
  };
  MD_MD.defaultProps = {
    tag: 'div'
  };
  /** @component */

  /* harmony default export */

  var views_MD = MD_MD; // CONCATENATED MODULE: ./src/views/LG.js

  function LG_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = LG_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function LG_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var LG_COMPONENT_ID = 'typography.lg';
  var StyledLG = external_styled_components_default.a.div.attrs({
    'data-garden-id': LG_COMPONENT_ID,
    'data-garden-version': "0.3.0"
  }).withConfig({
    displayName: "LG__StyledLG",
    componentId: "sc-18u1yr1-0"
  })(["line-height:", ";font-size:", ";direction:", ";", ";"], dist["zdLineHeightLg"], dist["zdFontSizeLg"], function (props) {
    return Object(react_theming_["isRtl"])(props) ? 'rtl' : 'ltr';
  }, function (props) {
    return Object(react_theming_["retrieveTheme"])(LG_COMPONENT_ID, props);
  });
  /**
   * Accepts all standard props relating to provided `tag`
   */

  var LG_LG = function LG(_ref) {
    var tag = _ref.tag,
        other = LG_objectWithoutProperties(_ref, ["tag"]);
    var CustomTagLG = StyledLG.withComponent(tag);
    return external_react_default.a.createElement(CustomTagLG, other);
  };

  LG_LG.propTypes = {
    /** Any valid DOM element for the styled component */
    tag: external_prop_types_default.a.any
  };
  LG_LG.defaultProps = {
    tag: 'div'
  };
  /** @component */

  /* harmony default export */

  var views_LG = LG_LG; // CONCATENATED MODULE: ./src/views/XL.js

  function XL_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = XL_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function XL_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var XL_COMPONENT_ID = 'typography.xl';
  var StyledXL = external_styled_components_default.a.div.attrs({
    'data-garden-id': XL_COMPONENT_ID,
    'data-garden-version': "0.3.0"
  }).withConfig({
    displayName: "XL__StyledXL",
    componentId: "sc-1ldfee8-0"
  })(["line-height:", ";font-size:", ";direction:", ";", ";"], dist["zdLineHeightXl"], dist["zdFontSizeXl"], function (props) {
    return Object(react_theming_["isRtl"])(props) ? 'rtl' : 'ltr';
  }, function (props) {
    return Object(react_theming_["retrieveTheme"])(XL_COMPONENT_ID, props);
  });
  /**
   * Accepts all standard props relating to provided `tag`
   */

  var XL_XL = function XL(_ref) {
    var tag = _ref.tag,
        other = XL_objectWithoutProperties(_ref, ["tag"]);
    var CustomTagXL = StyledXL.withComponent(tag);
    return external_react_default.a.createElement(CustomTagXL, other);
  };

  XL_XL.propTypes = {
    /** Any valid DOM element for the styled component */
    tag: external_prop_types_default.a.any
  };
  XL_XL.defaultProps = {
    tag: 'div'
  };
  /** @component */

  /* harmony default export */

  var views_XL = XL_XL; // CONCATENATED MODULE: ./src/views/XXL.js

  function XXL_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = XXL_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function XXL_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var XXL_COMPONENT_ID = 'typography.xxl';
  var StyledXXL = external_styled_components_default.a.div.attrs({
    'data-garden-id': XXL_COMPONENT_ID,
    'data-garden-version': "0.3.0"
  }).withConfig({
    displayName: "XXL__StyledXXL",
    componentId: "z9aic3-0"
  })(["line-height:", ";font-size:", ";direction:", ";", ";"], dist["zdLineHeightXxl"], dist["zdFontSizeXxl"], function (props) {
    return Object(react_theming_["isRtl"])(props) ? 'rtl' : 'ltr';
  }, function (props) {
    return Object(react_theming_["retrieveTheme"])(XXL_COMPONENT_ID, props);
  });
  /**
   * Accepts all standard props relating to the provided `tag`
   */

  var XXL_XXL = function XXL(_ref) {
    var tag = _ref.tag,
        other = XXL_objectWithoutProperties(_ref, ["tag"]);
    var CustomTagXXL = StyledXXL.withComponent(tag);
    return external_react_default.a.createElement(CustomTagXXL, other);
  };

  XXL_XXL.propTypes = {
    /** Any valid DOM element for the styled component */
    tag: external_prop_types_default.a.any
  };
  XXL_XXL.defaultProps = {
    tag: 'div'
  };
  /** @component */

  /* harmony default export */

  var views_XXL = XXL_XXL; // CONCATENATED MODULE: ./src/views/XXXL.js

  function XXXL_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = XXXL_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function XXXL_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var XXXL_COMPONENT_ID = 'typography.xxxl';
  var StyledXXXL = external_styled_components_default.a.div.attrs({
    'data-garden-id': XXXL_COMPONENT_ID,
    'data-garden-version': "0.3.0"
  }).withConfig({
    displayName: "XXXL__StyledXXXL",
    componentId: "sc-1iape3l-0"
  })(["line-height:", ";font-size:", ";direction:", ";", ";"], dist["zdLineHeightXxxl"], dist["zdFontSizeXxxl"], function (props) {
    return Object(react_theming_["isRtl"])(props) ? 'rtl' : 'ltr';
  }, function (props) {
    return Object(react_theming_["retrieveTheme"])(XXXL_COMPONENT_ID, props);
  });
  /**
   * Accepts all standard props relating to provided `tag`
   */

  var XXXL_XXXL = function XXXL(_ref) {
    var tag = _ref.tag,
        other = XXXL_objectWithoutProperties(_ref, ["tag"]);
    var CustomTagXXXL = StyledXXXL.withComponent(tag);
    return external_react_default.a.createElement(CustomTagXXXL, other);
  };

  XXXL_XXXL.propTypes = {
    /** Any valid DOM element for the styled component */
    tag: external_prop_types_default.a.any
  };
  XXXL_XXXL.defaultProps = {
    tag: 'div'
  };
  /** @component */

  /* harmony default export */

  var views_XXXL = XXXL_XXXL; // CONCATENATED MODULE: ./src/views/Ellipsis.js

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function Ellipsis_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Ellipsis_objectWithoutPropertiesLoose(source, excluded);
    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function Ellipsis_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */


  var Ellipsis_COMPONENT_ID = 'typography.ellipsis';
  var StyledEllipsis = external_styled_components_default.a.div.attrs({
    'data-garden-id': Ellipsis_COMPONENT_ID,
    'data-garden-version': "0.3.0"
  }).withConfig({
    displayName: "Ellipsis__StyledEllipsis",
    componentId: "sc-5rma8w-0"
  })(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;direction:", ";", ";"], function (props) {
    return Object(react_theming_["isRtl"])(props) ? 'rtl' : 'ltr';
  }, function (props) {
    return Object(react_theming_["retrieveTheme"])(Ellipsis_COMPONENT_ID, props);
  });
  /**
   * A component that automatically includes a native `title` attribute
   * and any text-overflow styling.
   *
   * All other props are spread onto the element.
   *
   * @param {*} props
   */

  function Ellipsis(_ref) {
    var children = _ref.children,
        title = _ref.title,
        tag = _ref.tag,
        other = Ellipsis_objectWithoutProperties(_ref, ["children", "title", "tag"]);
    var CustomTagEllipsis = StyledEllipsis.withComponent(tag);
    var textContent = null;

    if (title !== undefined) {
      textContent = title;
    } else if (typeof children === 'string') {
      textContent = children;
    }

    return external_react_default.a.createElement(CustomTagEllipsis, _extends({
      title: textContent
    }, other), children);
  }

  Ellipsis.propTypes = {
    /**
     * Optional override for the auto-generated `title` attribute
     */
    title: external_prop_types_default.a.string,

    /** Any valid element for the styled component */
    tag: external_prop_types_default.a.any,
    children: external_prop_types_default.a.string
  };
  Ellipsis.defaultProps = {
    tag: 'div'
  };
  /* harmony default export */

  var views_Ellipsis = Ellipsis; // CONCATENATED MODULE: ./src/index.js

  /* concated harmony reexport SM */

  __webpack_require__.d(__webpack_exports__, "SM", function () {
    return views_SM;
  });
  /* concated harmony reexport MD */


  __webpack_require__.d(__webpack_exports__, "MD", function () {
    return views_MD;
  });
  /* concated harmony reexport LG */


  __webpack_require__.d(__webpack_exports__, "LG", function () {
    return views_LG;
  });
  /* concated harmony reexport XL */


  __webpack_require__.d(__webpack_exports__, "XL", function () {
    return views_XL;
  });
  /* concated harmony reexport XXL */


  __webpack_require__.d(__webpack_exports__, "XXL", function () {
    return views_XXL;
  });
  /* concated harmony reexport XXXL */


  __webpack_require__.d(__webpack_exports__, "XXXL", function () {
    return views_XXXL;
  });
  /* concated harmony reexport Ellipsis */


  __webpack_require__.d(__webpack_exports__, "Ellipsis", function () {
    return views_Ellipsis;
  });
  /**
   * Copyright Zendesk, Inc.
   *
   * Use of this source code is governed under the Apache License, Version 2.0
   * found at http://www.apache.org/licenses/LICENSE-2.0.
   */

  /***/

}
/******/
]));